import { render } from "./CoBrandCypher.vue?vue&type=template&id=019044a4&scoped=true"
import script from "./CoBrandCypher.vue?vue&type=script&lang=js"
export * from "./CoBrandCypher.vue?vue&type=script&lang=js"

import "./CoBrandCypher.vue?vue&type=style&index=0&id=019044a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019044a4"]])

export default __exports__